exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".map-marker{position:absolute;width:32px;height:32px;left:-16px;top:-16px;border:3px solid #41464b;border-radius:32px;background-color:#fff;text-align:center;color:#3f51b5;font-size:12px;font-weight:700;padding:6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/MapMarker.scss
// module id = 648
// module chunks = 0